import React from "react";
import { motion } from "framer-motion";
import MotionDivPart from "./MotionDiv";
import useTranslation from "../Constant";

const About = ({darkMode}) => {
  const Constant = useTranslation()
  const handleNavigate=()=>{

  }
  return (
    <div id="about" className={darkMode === true ? "bg-white" : "bg-gray-900"}>
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 md:mt-0 pt-24 pb-12">
        <h2
          className={
            darkMode
              ? "text-5xl font-bold px-4 md:px-0 text-center"
              : "text-5xl font-bold px-4 md:px-0 text-center text-white"
          }
        >
          About Me
        </h2>
        <div>
          <MotionDivPart heading={"A bit about me"} content={Constant.about} darkMode={darkMode} detailAbout={Constant.detailAbout}/>
          <MotionDivPart heading={"Technologies and Tools"} content={Constant.technologies_tools} darkMode={darkMode}/>
          <MotionDivPart heading={"Education"} content={Constant.education} darkMode={darkMode}/>
          
          <motion.div className="mt-8 flex flex-wrap justify-between ">
            {Constant.techStack.map((el, index) => (
              <a href={el.source} target="_blank" key={index} rel="noreferrer" >
                <motion.div key={index}
                  initial="hidden"
                  whileInView={"visible"}
                  variants={{
                    visible: {
                      y: 0,
                      opacity: 1,
                      transition: {
                        type: "spring",
                      },
                    },
                    hidden: { opacity: 1, y: 80 },
                  }}
                  onClick={()=>handleNavigate(el)}
                  className="py-2 px-4 bg-gray-50 md:m-4 mx-2 mt-6 rounded-lg flex items-center hover:scale-125 cursor-pointer md:w-48 w-40"
                >
                  <img alt="stack-logo" src={el.link} className="w-12" />
                  <h4 className="text-md ml-4">{el.name}</h4>
                </motion.div>
              </a>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;
